export enum AcademyAdministratorType{
    HEADQUARTERS = 'Headquarters',
    SEASONS = 'Seasons',
    SCHS = "Schs",
    COURSES_LEVELS = 'CoursesAndLevels',
    GROUPS = 'ClassGroups',
    PRODUCTS_SERVICES = "ProductAndServices",
    AGREEMENTS_DISCOUNTS ="AgreementsAndDiscounts",
    INSTRUCTORS = 'Instructors',
    MEMBERS = 'members',
    MEMBERS_MASSIVE = 'MembersMassive',
    LEGACY_MEMBERS = 'legacyMembers',
    MEMBERSHIPS = 'memberships',
    MASSIVE_GROUPS = 'MassiveClassGroups',
    CANCELLATIONS = 'Cancellations',
    CLUBES = 'clubes',
    MODALITIES = 'modalities',
    COMPETIIONS = 'competitions',
    CATEGORIES = 'categories',
    LEVELS = 'levels',
    REGISTRATIONS = 'registrations',
}